import React, { useContext, useState } from "react";

import { useTranslation } from "react-i18next";

import Card from "react-bootstrap/Card";
import SpinnerLoading from "../Common/SpinnerLoading";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { useHistory } from "react-router-dom";

const CertificateDetailQuckLink = () => {

  const {
      updateLocTab,
    } = useContext(GlobalContext);
  const history = useHistory();
  const { t: translator } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  let config = {
    headers: {
      "X-IsMockup": false,
    },
  };
  // TODO get tenant first store with locTab cijenik

 const handleClick = () => {
    updateLocTab("certificates");
    history.push("/tenants/"+localStorage.getItem("tenantId"));
  };

  return (
    <>
      {isLoading && (
        <div className="dashboard-card-spinner">
          <SpinnerLoading />
        </div>
      )}

      {!isLoading && (
        <>
         <a onClick={()=>handleClick()} href="">
         <Card.Body className="dashboard-card-body-quick-link">
           
              <div className="dashboard-card-body-quick-link-image">
              <span
                className="icon icon-code-file"
                style={{ fontSize: 50 }}
              ></span>
            </div>
            <div className="dashboard-card-body-quick-link-simpleData">
              Certifikati
            </div>
           
          </Card.Body>
           </a>
        </>
      )}
    </>
  );
};

export default CertificateDetailQuckLink;
